<script setup lang="ts">
  import FlowPathInput from '@/components/form/FlowPathInput.vue'
  import DynamicVariableInput from '@/components/form/DynamicVariableInput.vue'
  import {
    FormFieldContainer,
    InputField,
    type DataAggregator,
  } from '@logistiek-zonder-papier/lzp-library'

  const field = defineModel<DataAggregator>({ required: true })
</script>

<template>
  <div class="field-config-container">
    <FormFieldContainer label="Name">
      <FlowPathInput
        placeholder="Debug placeholder"
        v-model="field.name"
        :optional="false"
        type="text"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <DynamicVariableInput
      label="Array Source"
      placeholder="x path to the source"
      v-model="field.sourceArray"
      type="text"
      :optional="false"
      :validate-paths="true"
    />

    <DynamicVariableInput
      label="Element Target"
      placeholder="x path to target in array elements"
      v-model="field.elementTarget"
      type="text"
      :optional="false"
      :validate-paths="true"
    />

    <FormFieldContainer label="Store Location">
      <InputField
        placeholder="x.path.to.location"
        hint="Target path url."
        v-model="field.storeLocation"
        type="text"
      />
    </FormFieldContainer>
  </div>
</template>

<style scoped>
  .field-config-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  .test-row {
    display: flex;
    justify-content: flex-end;
    margin-top: 0.25rem;
  }
</style>
